import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { APP_STATE, useApp } from 'providers';
import { AuthPage, LoadingPage, DepositRouter } from 'pages';
import { ROUTES } from 'routes';
import { useLogout } from 'hooks';
import { ACTIONS, setCookie } from 'utils';
import { DepositAction } from 'types';

export const App = (): React.ReactElement | null => {
  const { appState, user } = useApp();
  const { pathname } = useLocation();
  const isConnected = !!(user?.refreshToken && user?.accessToken);
  let depositAction: DepositAction = 'deposit';
  let ref = undefined;
  useLogout();

  const matchRedirection = matchPath(pathname, {
    path: [ROUTES.renew(), ROUTES.upsell(), ROUTES.update(), ROUTES.phoneValidationUpdate()],
  });
  if (matchRedirection) {
    const { reference, action } = matchRedirection.params as { reference: string; action: keyof typeof ACTIONS };
    depositAction = action as DepositAction;
    ref = reference;
    //window.location.href = config.URL_LEGACY_DEPOSIT + `classified/${reference}/${ACTIONS[action]}`;
  }

  if (appState === APP_STATE.LOADING) {
    const match = matchPath(pathname, { path: ROUTES.category(), exact: true });
    if (match) {
      setCookie('origin', pathname);
    }
    return <LoadingPage />;
  } else {
    return isConnected ? <DepositRouter action={depositAction} reference={ref} /> : <AuthPage />;
  }
};
